import { render, staticRenderFns } from "./PageHelp.vue?vue&type=template&id=dc917064&"
import script from "./PageHelp.vue?vue&type=script&lang=js&"
export * from "./PageHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports